/**
 * React Query hook for fetching scan quota information.
 */

import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/services/api";
import type { ScanQuota } from "@/types/user";

/**
 * Hook to fetch scan quota for a user.
 *
 * @param username - Username to fetch quota for
 * @returns Query result with scan quota data
 */
export function useScanQuota(username: string | undefined) {
  return useQuery<ScanQuota>({
    queryKey: ["scanQuota", username],
    queryFn: async () => {
      if (!username) throw new Error("Username required");
      const data = await apiClient.get<ScanQuota>(`/api/v1/user/${username}/scan-quota`);
      return data;
    },
    enabled: !!username,
    staleTime: 30000, // 30 seconds
  });
}
